import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { errMsg } from "../lib/api";
import { Brand } from "../components/Layout";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

const HERO = "https://images.unsplash.com/photo-1574023240744-64c47c8c0676?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try { await login(email, password); nav("/"); }
    catch (err) { setError(errMsg(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-[1.1fr_1fr]">
      <div className="relative hidden overflow-hidden bg-[#0F1B2D] lg:block">
        <img src={HERO} alt="Showroom" className="absolute inset-0 h-full w-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0F1B2D] via-[#0F1B2D]/60 to-transparent" />
        <div className="relative flex h-full flex-col justify-between p-12">
          <Brand />
          <div className="rise max-w-md">
            <ShieldCheck className="mb-5 h-10 w-10 text-[#D4B98A]" />
            <h1 className="font-display text-4xl font-black leading-tight text-white xl:text-5xl">
              Garanzie di conformità e commerciali, sotto controllo.
            </h1>
            <p className="mt-4 text-slate-300">Registro garanzie, scadenze e interventi in officina per lo staff della concessionaria.</p>
          </div>
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500">D.Lgs 206/2005 · Codice del Consumo</div>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <form onSubmit={submit} className="rise w-full max-w-sm space-y-6" data-testid="login-form">
          <div className="lg:hidden"><Brand dark={false} /></div>
          <div>
            <h2 className="font-display text-3xl font-extrabold tracking-tight">Accesso staff</h2>
            <p className="mt-1 text-sm text-muted-foreground">Gli account sono creati dall'amministratore.</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" className="h-11" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" className="h-11" />
          </div>
          {error && <div className="rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="login-error">{error}</div>}
          <Button type="submit" disabled={loading} className="h-11 w-full bg-[#B08D57] font-semibold hover:bg-[#96764A]" data-testid="login-submit-button">
            {loading ? "Accesso in corso…" : "Accedi"}
          </Button>
        </form>
      </div>
    </div>
  );
}
